<template>
  <div id="home">
    <nosotros />
    <trabajo />
    <productos />
    <proyectos />
  </div>
</template>

<script>
import Nosotros from '@/components/Nosotros.vue'
import Trabajo from '@/components/Trabajo.vue'
import Productos from '@/components/Productos.vue'
import Proyectos from '@/components/Proyectos.vue'

export default {
  components: {
    Nosotros,
    Trabajo,
    Productos,
    Proyectos
  }
}
</script>
